import { LitElement, html, css } from 'lit'

class Accordion extends LitElement {
  static styles = css`
    :host {
      display: block;
      border-top: 1px solid var(--accordion-border-color, hsl(var(--theme-200)));
    }
  `
  render() {
    return html`
      <div>
        <slot></slot>
      </div>
    `
  }
}
customElements.define('accordion-container', Accordion)

class AccordionItem extends LitElement {
  static properties = {
    open: { reflect: true, type: Boolean },
  }

  static styles = css`
    :host {
      display: block;
      border-bottom: 1px solid var(--accordion-border-color, hsl(var(--theme-200)));
    }
    :host button:focus-visible {
      outline: var(--outline);
      outline-offset: var(--outline-offset);
      border-radius: var(--outline-radius);
    }
    :host([open]) {
    }
    :host([open]) button {
      color: hsl(var(--theme-400));
    }
    close-icon {
      --icon-stroke-color: hsl(var(--gray-700));
      --icon-stroke-width: 2;
    }
    button {
      font: var(--base);
      color: hsla(var(--text-color-dark));
      text-align: left;
      appearance: none;
      background: transparent;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0;
      border: none;
      cursor: pointer;
      gap:var(--gutter);
      padding: var(--spacing-6) 0;
      transition: all 150ms ease-in-out;
      font-weight: 300;
    }
    button:hover {
      color: hsl(var(--theme-400));
      -webkit-text-stroke: .6px currentColor;
    }
    :host([open]) button {
      color: hsl(var(--theme-400));
      -webkit-text-stroke: .6px currentColor;
    }
    :host([open]) .accordion-item__list__item {
      height: auto;
      max-width: 500px;
      margin: 0 0 var(--spacing-6);
      color: hsl(var(--gray-3));
      text-align: left;
      font: var(--base);
    }
    .accordion-item__list__item {
      height: 0;
      overflow: hidden;
    }
    @media (max-width: 430px) { 
      :host(:first-child) {
        border-top: none;
      }
    }
  `
  constructor() {
    super()
    this._regionId = String(Date.now()) + Math.floor(Math.random() * 10000)
    this._labelId = String(Date.now()) + Math.floor(Math.random() * 10000)
  }
  toggle() {
    // this._notChosenItems = Array.from(
    //   document.querySelectorAll('accordion-item')
    // ).filter((item) => item !== this)

    const wasOpen = this.open
    this.open = !this.open

    if (wasOpen) {
      this.button.setAttribute('aria-expanded', 'false')
      
    } else {
      this.button.setAttribute('aria-expanded', 'true')
      
      // this._notChosenItems.forEach((accordionItem) => {
      //   if (accordionItem.open) {
      //     accordionItem.open = false
      //     accordionItem.button.setAttribute('aria-expanded', 'false')
      //   }
      // })
    }
  }
  
  // updated(changedProperties) {
  //   if (changedProperties.has('open')) {
  //     if (!this.open) {
  //       this.querySelector('highlight-text').setAttribute('hover', 'hover')
  //     } else {
  //       this.querySelector('highlight-text').removeAttribute('hover')
  //     }
  //   }
  // }

  get button() {
    return this.shadowRoot.querySelector('button')
  }
  render() {
    return html`
      <div class="accordion-item">
        <button
          part="accordion-button"
          id="${this._labelId}"
          @click="${() => this.toggle()}"
          aria-expanded="${this.open ? 'true' : 'false'}"
          aria-controls="${this._regionId}"
        >
          <slot name="title"></slot>
          <close-icon ?open="${this.open}" ?closed="${!this.open}"></close-icon>
        </button>
        <div
          id="${this._regionId}"
          aria-labelledby="${this._labelId}"
          role="region"
          class="accordion-item__list__item"
        >
          <slot></slot>
        </div>
      </div>
    `
  }
}

customElements.define('accordion-item', AccordionItem)
